<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    showPercentInTooltip: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    chartData () {
      this.render()
    },
    showLegend () {
      this.render()
    },
    showPercentInTooltip () {
      this.render()
    }
  },
  computed: {
    options () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: 'bottom',
          labels: {
            boxWidth: 12
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex] || {}
              const value = Number((dataset.data || [])[tooltipItem.index] || 0)
              const label = data.labels?.[tooltipItem.index] || dataset.label || 'Lectures'

              if (!this.showPercentInTooltip) {
                return `${label}: ${this.formatNumber(value)}`
              }

              const configuredTotal = Number(data.tooltipTotal || 0)
              const total = configuredTotal > 0
                ? configuredTotal
                : (dataset.data || []).reduce((sum, item) => sum + Number(item || 0), 0)
              const percent = total > 0 ? ((value / total) * 100).toFixed(1) : '0.0'

              return `${label}: ${this.formatNumber(value)} (${percent} %)`
            }
          }
        }
      }
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    formatNumber (value) {
      return new Intl.NumberFormat('fr-FR').format(Number(value || 0))
    },
    render () {
      if (!this.chartData) {
        return
      }

      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
